import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Membership from "@/pages/Membership";
import Register from "@/pages/Register";
import Payment from "@/pages/Payment";
import Card from "@/pages/Card";
import Profile from "@/pages/Profile";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Directory from "@/pages/Directory";
import Events from "@/pages/Events";
import Videos from "@/pages/Videos";
import News from "@/pages/News";
import Grievance from "@/pages/Grievance";
import ComplaintDetail from "@/pages/ComplaintDetail";
import Verify from "@/pages/Verify";
import Feedback from "@/pages/Feedback";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/events" element={<Events />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/news" element={<News />} />
              <Route path="/verify" element={<Verify />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/register" element={<ProtectedRoute><Register /></ProtectedRoute>} />
              <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
              <Route path="/card" element={<ProtectedRoute><Card /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/directory" element={<ProtectedRoute><Directory /></ProtectedRoute>} />
              <Route path="/grievance" element={<ProtectedRoute><Grievance /></ProtectedRoute>} />
              <Route path="/complaint/:ticketId" element={<ProtectedRoute><ComplaintDetail /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
